import React, { useState } from "react";
import {
  Box,
  Typography,
  CircularProgress,
  Container,
  Slide,
} from "@mui/material";
import DocxViewer from "../TrainingMaterialViewers/DocxViewerPage";
import VideoPlayerPage from "../TrainingMaterialViewers/VideoPlayerPage";
import PdfViewer from "../TrainingMaterialViewers/PdfViewerPage";
import PptViewer from "../TrainingMaterialViewers/PptViewerPage";
import { GET_EMPLOYEE_TRAINING_SECTION_BY_ID } from "../../../apis/training-apis/trainingApis";
import { useSearchParams } from "react-router-dom";
import { useQuery, useMutation } from "@apollo/client";
import { UPDATE_TRAINING_SECTION_PROGRESS } from "../../../apis/training-apis/trainingApis";
import ConfirmSnackbar from "../../../components/Snackbar/ConfirmSnackbar";
import { GET_MASTER_LOOKUP_ID_BY_KEY } from "../../../apis/common-apis/commonApis";
import {
  TrainingSectionAttemptStatusKey,
  TrainingSectionTypeKey,
} from "../utils/enums";
import { MasterLookupItemsType } from "../../../utils/enums";

const TrainingSectionViewer = () => {
  const [searchParams] = useSearchParams();
  const querySectionId = searchParams.get("id");
  const sectionId = parseInt(querySectionId);
  const [snackbarInfo, setSnackbarInfo] = useState(null);

  const [updateTrainingSectionProgress] = useMutation(
    UPDATE_TRAINING_SECTION_PROGRESS
  );

  const { data: masterLookupId, loading: masterLookupIdLoading } = useQuery(
    GET_MASTER_LOOKUP_ID_BY_KEY,
    {
      variables: {
        type: MasterLookupItemsType.TRAINING_SECTION_ATTEMPT_STATUS,
        key: TrainingSectionAttemptStatusKey.COMPLETED,
      },
    }
  );

  const { data, loading, refetch } = useQuery(
    GET_EMPLOYEE_TRAINING_SECTION_BY_ID,
    {
      variables: { id: sectionId },
    }
  );

  const TransitionComponent = (props) => {
    return <Slide {...props} direction="left" />;
  };

  const handleUpdateTrainingSectionProgress = async (id, statusId) => {
    try {
      const message = await updateTrainingSectionProgress({
        variables: { training_section_id: id, status_id: statusId },
      });

      const response = message?.data?.updateTrainingSectionProgress;

      if (response?.success) {
        await refetch(); //  Refetch updated training list
        setSnackbarInfo({
          message: "Training completed!",
          vertical: "top",
          horizontal: "right",
          Transition: TransitionComponent,
        });

        return true;
      } else {
        console.error(
          "Falied to update status of course:",
          message?.updateTrainingModuleStatus?.message
        );
        setSnackbarInfo({
          message: "Error occured!",
          vertical: "top",
          horizontal: "right",
          Transition: TransitionComponent,
        });

        return false;
      }
    } catch (error) {
      console.error("Error in updating the status of course", error);
      return false;
    }
  };

  if (loading || masterLookupIdLoading) {
    return (
      <Container
        component="main"
        maxWidth="xs"
        sx={{ textAlign: "center", mt: 8 }}
      >
        <CircularProgress />
      </Container>
    );
  }

  const section = data?.getEmployeeTrainingSectionById?.data;

  const completedStatusId = masterLookupId?.getMasterLookupIdByKey?.id ?? 0;

  const renderViewer = () => {
    switch (section?.section_type_key) {
      case TrainingSectionTypeKey.VIDEO: // Video
        return (
          <VideoPlayerPage
            section={section}
            onUpdate={handleUpdateTrainingSectionProgress}
            refetch={refetch}
            completedStatusId={completedStatusId}
          />
        );
      case TrainingSectionTypeKey.DOCX: // Docx
        return (
          <DocxViewer
            section={section}
            onUpdate={handleUpdateTrainingSectionProgress}
            refetch={refetch}
            completedStatusId={completedStatusId}
          />
        );
      case TrainingSectionTypeKey.PDF: // PDF
        return (
          <PdfViewer
            section={section}
            onUpdate={handleUpdateTrainingSectionProgress}
            refetch={refetch}
            completedStatusId={completedStatusId}
          />
        );
      case TrainingSectionTypeKey.PPTX:
        return (
          <PptViewer
            section={section}
            onUpdate={handleUpdateTrainingSectionProgress}
            refetch={refetch}
            completedStatusId={completedStatusId}
          />
        );
      default:
        return <Typography variant="body2">Unsupported format</Typography>;
    }
  };

  return (
    <>
      <Box>{renderViewer()}</Box>
      <ConfirmSnackbar snackbarInfo={snackbarInfo} />
    </>
  );
};

export default TrainingSectionViewer;
